export default __webpack_public_path__ + "static/4-1d88007b16e66c43b80f2178ea2c1e4b.jpeg";